"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LEGEND_CONFIG = void 0;
const common_1 = require("../utils/common");
exports.DEFAULT_LEGEND_CONFIG = {
    showLegend: false,
    legendSize: NaN,
    legendValues: [],
    legendMaxDepth: Infinity,
    legendPosition: common_1.Position.Right,
    flatLegend: false,
};
//# sourceMappingURL=default_legend_config.js.map